export default "__VITE_ASSET__BtyZICtf__"